/**
 * Type definitions for the Recipe Editor V2
 */

export type TokenType = "quantity" | "ingredient_draft" | "ingredient";

export interface Token {
  from: number;
  to: number;
  type: TokenType;
}

export interface Suggestion {
  from: number;
  to: number;
  suggestedType: TokenType;
}

export interface ParsedRecipe {
  text: string;
  tokens: Token[];
}

/**
 * Clamps token positions to valid document bounds
 */
export function clampToken(t: Token, docLen: number): Token {
  const from = Math.max(0, Math.min(docLen, t.from));
  const to = Math.max(from, Math.min(docLen, t.to));
  return {...t, from, to};
}
